export default "__VITE_ASSET__IKs44zMe__"